/**
 * OpenClaw: the workspace IS the export. User-memory carriers: USER.md
 * (identity), MEMORY.md (curated long-term), memory/YYYY-MM-DD.md daily logs
 * (newest 90, dated). SOUL.md/IDENTITY.md are agent persona — imported as
 * "My assistant: …" preferences the review step can untick as a group.
 * Operational files (AGENTS/TOOLS/HEARTBEAT/BOOTSTRAP) are ignored.
 */
import { chunkMarkdown } from '../chunk.js';
import type { MemoryImportItem, NamedText } from '../types.js';
import { epistemicForHeading } from './generic.js';
import { basename, dateFromName } from './util.js';

const PERSONA_FILES = new Set(['soul.md', 'identity.md']);
const IGNORED_FILES = new Set(['agents.md', 'tools.md', 'heartbeat.md', 'bootstrap.md']);
const DAILY_CAP = 90;

export function parseOpenclaw(files: NamedText[]): MemoryImportItem[] {
  const items: MemoryImportItem[] = [];
  const daily: NamedText[] = [];

  for (const file of files) {
    if (!/\.md$/i.test(file.name)) continue;
    const base = basename(file.name).toLowerCase();
    if (IGNORED_FILES.has(base)) continue;
    if (/(^|\/)memory\//i.test(file.name) && dateFromName(file.name)) {
      daily.push(file);
    } else if (base === 'user.md') {
      items.push(...chunkMarkdown(file.text, basename(file.name), { epistemic: 'identity', epistemicForHeading }));
    } else if (base === 'memory.md') {
      items.push(...chunkMarkdown(file.text, basename(file.name), { epistemicForHeading }));
    } else if (PERSONA_FILES.has(base)) {
      items.push(...chunkMarkdown(file.text, 'Assistant persona', { epistemic: 'preference', prefix: 'My assistant: ' }));
    }
  }

  daily.sort((a, b) => b.name.localeCompare(a.name));
  for (const file of daily.slice(0, DAILY_CAP)) {
    const observedAt = dateFromName(file.name);
    items.push(
      ...chunkMarkdown(file.text, basename(file.name), {
        ...(observedAt ? { observedAt } : {}),
        epistemicForHeading,
      }),
    );
  }
  return items;
}
